// @flow
import styled from 'styled-components';
import Grid from 'styled-components-grid';
import breakpoint from 'styled-components-breakpoint';

import {
  px, pr, p, mx, my, py
} from 'styled-components-spacing';

import { StatefulButton } from '@components';

import theme from '@theme';

const { colors, borderRadius } = theme;

export const StyledWrapper = styled(Grid)`
  ${px(3)}
  ${py(2)}
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  color: ${colors.white};
  box-sizing: border-box;
  position: relative;

  ${breakpoint('desktop')`
  ${px(5)}
  ${py(3)}
`}

  ${breakpoint('largeDesktop')`
    max-width: 1500px;
    margin: 0 auto;
    ${({ isMapVisible }) => isMapVisible && 'justify-content: flex-start;'}
  `}
`;

export const StyledHeading = styled.h2`
  font-size: 18px;
  text-transform: uppercase;
  font-weight: bolder;
  color: ${theme.colors.navyGray};
  width: 100%;
  border-bottom: 1px solid ${colors.translucentDarkBlue};

  ${theme.typography.Raleway}

  ${px(2)}
  ${py(4)}

  ${breakpoint('desktop')`
    font-size: 22px;
  `}
`;

export const StyledParametersContainer = styled.div`
  display: flex;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: auto;

  ${breakpoint('desktop')`
    justify-content: flex-start;
    flex: 1;
    ${my(2)}
  `}

  ${my(1)}

  & > * {
    ${my(1)}

    ${breakpoint('desktop')`
      ${my(0)}
    `}
  }
`;

export const StyledInnerWrapper = styled.div`
  width: 100%;
  max-width: 1500px;

  box-sizing: border-box;
  position: relative;

  display: flex;

  justify-content: space-between;
  align-items: center;

  ${breakpoint('largeDesktop')`
    ${({ isMapVisible }) =>
    isMapVisible
      && `
      justify-content: space-between;
      flex: 1;
      max-width: 100%;
    `}
  `}
`;

export const StyledSeparationLine = styled.div`
  border-left: solid white 1px;
  height: 1em;
  align-self: center;
  opacity: 0.2;

  display: flex;

  ${mx(2)}

  ${breakpoint('desktop')`
    margin-left: unset;
    margin-right: unset;
  `}
`;

export const StyledButton = styled.button`
  background-color: transparent;
  border: ${colors.translucentWhite} solid 2px;
  color: ${colors.white};
  width: 82px;
  ${p(3)}
  ${borderRadius.small}
`;

export const StyledShowMapCheckbox = styled(Grid.Unit)`
  justify-content: flex-end;
  align-items: center;
  color: ${colors.aquaMarine};

  ${breakpoint('desktop')`
    font-size: 22px;
    font-weight: bolder;
  `}
`;

export const StyledTextLabel = styled.span`
  ${pr(3.5)}
  cursor: pointer;
`;

export const StyledMobileFiltersButton = styled.button`
  min-width: 82px;
  height: 29px;
  color: black;
  background-color: ${colors.white};
  border: none;
  cursor: pointer;
  color: ${colors.translucentDarkBlue};
  font-weight: 700;
  font-size: 14px;
  border-radius: 5px;
  box-shadow: 0 5px 3px 0px ${colors.transluscentDark};
  ${breakpoint('tablet', 'desktop')`
  height: 40px;
  `};
`;

export const StyledShowMapFloatingButton = styled(StatefulButton)`
  position: fixed;

  bottom: ${theme.spacing[3.5]};
  left: ${theme.spacing[3.5]};

  width: 60px;

  z-index: 100;

  ${breakpoint('desktop')`
    display: none;
  `}
`;
